<template>

<b-container>
  <b-alert
    :show="dismissCountDown"
    dismissible
    variant="success"
    @dismissed="dismissCountDown=0"
    @dismiss-count-down="countDownChanged"
  >
    <p>{{ alertcontent }}</p>
    <b-progress
    variant="warning"
    :max="dismissSecs"
    :value="dismissCountDown"
    height="4px"
    ></b-progress>
  </b-alert>
  <!-- v-b-modal.modal-1 -->
  <b-col md="12" class="my-5 p-0">
    <div v-if="user.userLevel == 0">
      <p class="m-0">Accessing professional experts for mentoring at your finger tips.</p>
      <p  class="m-0">Feel burned out and want to avoid noob mistakes, mentor will help you achieve your goals faster.</p>
    </div>
    <div v-if="user.userLevel == 50">
      <p class="m-0">Fulfilling your life more through sharing your professional wisdom and advise never be any easier or pump.</p>
    </div>

    <b-row class="my-5">
        <b-col cols="12" sm="6" class="py-2">
          <span class="inline-block"><span class="font-24 font-weight-bold" v-if="user.userLevel == 0">Tickets</span><span class="font-24 font-weight-bold" v-else>Private tickets</span><strong> {{ filterSererity.length }} Records Found, Page {{currentPage }} of {{Math.ceil(totalRows/perPage)}}</strong></span>

        </b-col>
        <b-col cols="12" sm="6" class="py-2">
          <b-row >
            <b-col cols="12" sm="8" class="text-right py-1 ">
              <b-input-group  >
                <i class="fas fa-search"></i>
                <b-form-input :autofocus="true" v-model="filter" style="border-radius: 50px;padding-left:40px;width: 26%;" placeholder="Search subject" >
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col v-if="user.userLevel == 50" cols="12" sm="4" class="tCenter py-1">
              <b-button   @click="openNav()" :class="{activefilter : isfilter }" id="Filters" class="Filters ">
                <span class="white px-3">
                  <i class="fas fa-filter"></i> FILTERS 
                </span>
              </b-button>
            </b-col>
            <b-col v-if="user.userLevel == 0" cols="12" sm="4" class="tCenter py-1 ">          
              <b-button  @click="openCreatMentor"  
              ><span class="px-2"><i class="fas fa-plus"></i> Create Ticket </span></b-button>
            </b-col>
          </b-row>
        </b-col>
    </b-row>


  </b-col>
    <b-table
      :busy="isBusy"
      :bordered="true"
      :hover="true"
      show-empty
      stacked="lg"
      :items="filterSererity"
      :fields="user.userLevel == 0 ? selectrecord : selectrecordMentor"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
        @filtered="onFiltered"
    >
    <div slot="table-busy" class="text-center text-danger my-2 loading">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Loading...</strong>
    </div>

    <template slot="ticketNo"  slot-scope="row" >
      <div class="text-center" v-if="user.userLevel == 0">
        <i class="fas fa-users" v-if="row.item.mentorId" v-b-tooltip.hover v-b-tooltip.html :title="'Owner: '+user.name +' '+user.surname +'<br>Commentator: '+ row.item.mentorName+' '+row.item.mentorSurname"></i>
        <i class="fas fa-globe-asia" v-else v-b-tooltip.hover title="Public"></i>
        <span>{{row.item.ticketNo}}</span>
      </div>
      <div class="text-center" v-else>
        <i class="fas fa-users" 
              v-b-tooltip.html 
              :title="'Owner: '+ row.item.name+' '+row.item.surname + 
              '<br>Commentator: '+user.name +' '+user.surname" ></i>
        <!-- :title="'Owner: '+row.item.comments[0].name +' '+row.item.comments[0].surname +'<br>Commentator: '+ user.name+' '+user.surname" -->
        <span>{{row.item.ticketNo}} </span> 
      </div>
    </template>
    
   <template slot="severityStatus" style="text-align:center" slot-scope="row" v-if="user.userLevel > 0">
      <div>
        <span :class="{'text-back':row.item.severityStatus == 2 , 'text-orange':row.item.severityStatus == 3 , 'text-danger':row.item.severityStatus == 4}">
          {{ convertseverity(row.item.severityStatus)}}
        </span>
      </div>
    </template>

    <template slot="subject" slot-scope="row">
      <div :title="row.item.subject">
       <span v-if="user.userLevel == 50">{{row.item.subject | snippetSmall}}</span>
       <span v-else>{{row.item.subject | snippetMore}}</span>
      </div>
    </template>

    <template slot="status" style="text-align:center" slot-scope="row">
      <!-- {{ row }}  -->
      <!-- <b-button class="CLOSED" v-if="row.item.status == 6">CLOSED</b-button>
      <b-button class="OPEN" v-if="row.item.status == 1">OPEN</b-button>
      <b-button class="ONHOLD" v-if="row.item.status == 3">ON HOLD</b-button>
      <b-button class="COMPANY-REPLY" v-if="row.item.status == 5">COMPANY-REPLY</b-button>
      <b-button class="ANSWERED" v-if="row.item.status == 2" >ANSWERED</b-button>
      <b-button class="inprocress" v-if="row.item.status == 4" >inprocress</b-button> -->
      <b-button class="CLOSED status-btn cr-defualt" v-if="row.item.status == 6" ><span class="font-14 css-btn">CLOSED</span></b-button>
      <b-button class="OPEN status-btn cr-defualt" v-if="row.item.status == 1" ><span class="font-14 css-btn">OPEN</span></b-button>
      <b-button class="ONHOLD status-btn cr-defualt" v-if="row.item.status == 3" ><span class="font-14 css-btn">ON HOLD</span></b-button>
      <b-button class="COMPANY-REPLY status-btn cr-defualt" v-if="row.item.status == 5"><span class="font-14 css-btn">COMPANY-REPLY</span></b-button>
      <b-button class="ANSWERED status-btn cr-defualt"  v-if="row.item.status == 2"><span class="font-14 css-btn">ANSWERED</span></b-button>
      <b-button class="inprocress status-btn cr-defualt"  v-if="row.item.status == 4"><span class="font-14 css-btn">IN-PROCESS</span></b-button>
    </template>

    <template slot="category" slot-scope="row">
      <span style="width: 97px; display: block;">{{checkNameCategory(row.item.category)}}</span>
    </template>
    <template slot="createDate" slot-scope="row">
      <span style="width: 97px; display: block;">{{covertime(row.item.createDate)}}</span>
    </template>
    <template slot="updateDate" slot-scope="row" class="text-center">
      <span style="width: 97px; display: block;">{{covertime(row.item.updateDate)}}</span>
  
    </template>
    <template slot="isclose" slot-scope="row">
        <a  @click="changerouter(row.item)"><h6  class="hoverblue">View</h6></a>
    </template>
    <template slot="actions" slot-scope="row">
      <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
      Info modal
      </b-button>
      <b-button size="sm" @click="row.toggleDetails">
      {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
      </b-button>
    </template>
    <template slot="row-details" slot-scope="row">
      <b-card>
      <ul>
        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
      </ul>
      </b-card>
    </template>
  </b-table>
  <b-row class="mb-5">
    <b-col md="6" class="my-1" v-if="totalRows > 10">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="my-0"
      ></b-pagination>
    </b-col>
  </b-row>
  <b-row class="my-5">
    <b-col cols="12" sm="6" class="py-2">
        <span class="font-24 font-weight-bold">Your match tickets</span><strong> {{ ticketAll.length }} Records Found, Page {{currentPage }} of {{Math.ceil(totalRows/perPage)}}</strong>
    </b-col>
    <b-col cols="12" sm="6" class="py-2">
      <b-row >
        <b-col cols="12" sm="8" class="text-right py-1 ">
          <b-input-group>
            <i class="fas fa-search"></i>
            <b-form-input :autofocus="true" v-model="filterAll" style="border-radius: 50px;padding-left:40px;width: 26%;" placeholder="Search subject" >
            </b-form-input>
          </b-input-group>
        </b-col>
        <b-col v-if="user.userLevel == 50" cols="12" sm="4" class="tCenter py-1">
          <b-button  v-if="user.userLevel == 50" @click="openNavAll()" :class="{activefilter : isfilter }" id="Filters" class="Filters">
            <span class="white px-3">
              <i class="fas fa-filter"></i> FILTERS 
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  
  <b-table
    v-if="user.userLevel == 50"
    :busy="isBusy"
    :bordered="true"
    :hover="true"
    show-empty
    stacked="lg"
    :items="filterSererityAll"
    :fields="user.userLevel == 0 ? selectrecord : selectrecordMentor"
    :current-page="currentPageAll"
    :per-page="perPageAll"
    :filter="filterAll"
    :sort-by.sync="sortByAll"
    :sort-desc.sync="sortDescAll"
    :sort-direction="sortDirectionAll"
    @filtered="onFilteredAll"
    >

    <div slot="table-busy" class="text-center text-danger my-2 loading">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Loading...</strong>
    </div>

    <template slot="ticketNo"  slot-scope="row" >
      <div class="text-center">
        <!-- <i class="fas fa-users" v-if="row.item.mentorId"></i> -->
        <i class="fas fa-globe-asia" v-b-tooltip.hover title="Public"></i>
        <span>{{row.item.ticketNo}}</span>
      </div>
    </template>

   <template slot="severityStatus" style="text-align:center" slot-scope="row" v-if="user.userLevel > 0">
      <div>
        <span :class="{'text-back':row.item.severityStatus == 2 , 'text-orange':row.item.severityStatus == 3 , 'text-danger':row.item.severityStatus == 4}">
          {{ convertseverity(row.item.severityStatus)}}
        </span>
      </div>
    </template>
     <template slot="subject" slot-scope="row">
      <div :title="row.item.subject">
       <span >{{row.item.subject | snippetSmall}}</span>
      </div>
    </template>
    <template slot="status" style="text-align:center" slot-scope="row">
      <b-button class="CLOSED status-btn" v-if="row.item.status == 6"><span class="css-btn font-14">CLOSED</span></b-button>
      <b-button class="OPEN status-btn" v-if="row.item.status == 1"><span class="css-btn font-14">OPEN</span></b-button>
      <b-button class="ONHOLD status-btn" v-if="row.item.status == 3"><span class="css-btn font-14">ON HOLD</span></b-button>
      <b-button class="COMPANY-REPLY status-btn" v-if="row.item.status == 5"><span class="css-btn font-14">COMPANY-REPLY</span></b-button>
      <b-button class="ANSWERED status-btn" v-if="row.item.status == 2" ><span class="css-btn font-14">ANSWERED</span></b-button>
      <b-button class="inprocress status-btn" v-if="row.item.status == 4" ><span class="css-btn font-14">IN-PROCESS</span></b-button>
    </template>

    <template slot="category" slot-scope="row">
      <span style="width: 97px; display: block;">{{checkNameCategory(row.item.category)}}</span>
    </template>

    <template slot="createDate" slot-scope="row">
      <span style="width: 97px; display: block;">{{covertime(row.item.createDate)}}</span>
    </template>

    <template slot="updateDate" slot-scope="row" class="text-center">
      <span style="width: 97px; display: block;">{{covertime(row.item.updateDate)}}</span>
    </template>

    <template slot="isclose" slot-scope="row">
      <a  @click="changerouter(row.item)"><h6  class="hoverblue">View</h6></a>
    </template>

    <template slot="actions" slot-scope="row">
      <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
      Info modal
      </b-button>
      <b-button size="sm" @click="row.toggleDetails">
      {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
      </b-button>
    </template>

    <template slot="row-details" slot-scope="row">
      <b-card>
      <ul>
        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
      </ul>
      </b-card>
    </template>

  </b-table>
  <b-row class="mb-5" v-if="user.userLevel == 50">
    <b-col md="6" class="my-1" v-if="totalRowsAll > 10">
      <b-pagination
        v-model="currentPageAll"
        :total-rows="totalRowsAll"
        :per-page="perPageAll"
        class="my-0"
      ></b-pagination>
    </b-col>
  </b-row>



    <!-- Info modal -->
  <b-modal  :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
    <pre>{{ infoModal.content }}</pre>
  </b-modal>
    <!-- new Service -->
  <b-modal v-model="modalservice" hide-header hide-footer id="modal-1" size="lg">
    <b-container>
    <div class="d-flex justify-content-between mt-4" style="position:relative">
      <span @click="backcategory" style="color:#C4C4C4;cursor:pointer" class="back-to-cat"><i class="fas fa-chevron-left"></i> Back to category</span>
      
      <h2 class="abcenter"><strong>Choose category</strong></h2>
      <i @click="modalservice = !modalservice" class="fas fa-times"></i>
    </div>
    <h6  class="mt-4" v-if="typeof user.mentorDetail != 'undefined' && user.mentorDetail != null && modaldepartmentsType === 'booking'"><strong>Mentor </strong>{{user.mentorDetail.detailUser[0].name}} {{user.mentorDetail.detailUser[0].surname}}</h6>
    <h6  class="mt-2"><strong>Category </strong>{{checkNameCategory(category_select)}}</h6>
        <!-- <h5 class="float-left">New Service Request  </h5>    <b-badge class="float-left" pill variant="primary"></b-badge> -->
    <h6 class="mb-1 mt-3"><strong>Subject</strong> </h6>
    <b-form-input v-model="newservice.topic" placeholder="Type Topic"></b-form-input>
    <b-row>
      <b-col md="6">
        <h6 class="mb-1 mt-3"><strong>Type of business:</strong>   </h6>
        <b-form-select v-model="newservice.selectinvesting" :options="typeOfBusiness"></b-form-select>
      </b-col>
      <b-col md="6">
        <h6 class="mb-1 mt-3"><strong> Severity :</strong> </h6>
          <b-form-select v-model="newservice.selectedSeverity" :options="optionseverity"></b-form-select>
      </b-col>
    </b-row>
      <h6 class="mb-1 mt-3"><strong>Details :</strong> </h6>
      <b-form-textarea
      id="textarea"
      v-model="newservice.detail"
      placeholder="Enter something..."
      rows="6"
      max-rows="6"
      ></b-form-textarea>
      <h6 class="mb-1 mt-3"><strong>Attachment</strong> 
        <span class="grey">(Allow File Extensions: .jpg, .gif, .jpeg, .png)</span> 
      </h6>
      <!-- {{newservice.file}} -->
        <b-row v-for="(item,index) in newservice.file" :key="index">
          <b-col md="11">
            <!-- <span class="ab-file-name">
              {{(item.status === 1)?item.fileName:(item.status === 0)?'อัพโหลดไฟล์ล้มเหลว':(item.status === 2)?'กำลังโหลด...':''}}
            </span> -->
            <b-form-file
            placeholder="Choose a file..."
            drop-placeholder="Drop file here..."
            :file-name-formatter="()=>{
              return (item.status === 1)?item.fileName:(item.status === 0)?'อัพโหลดไฟล์ล้มเหลว':(item.status === 2)?'กำลังโหลด...':'Choose a file...'
            }"
            @change="uploadfile_post($event,index)"
            >
            </b-form-file>
          </b-col>
          <b-col md="1" align-self="center" class="p-0" v-if="newservice.file.length >1">
            <label class="text-danger cr-pointer" @click="delFile(index)"><i class="fas fa-minus-circle"></i></label>
          </b-col>
      </b-row>
      <label class="orange mr-2 cr-pointer" @click="addmorefile()"><font-awesome-icon icon="plus-circle"  /> Add More </label>
      <!-- <div class="mb-2  " >
          <span class="mr-2 orange cr-pointer" @click="addmorefile"> <font-awesome-icon icon="plus-circle"  /> Add More</span> 
          <span v-if="file.length > 1" class="text-danger cr-pointer" @click="cancel(file.length-1)"> <i class="fas fa-minus-circle "></i> Cancel</span>
      </div> -->
      <div class="mt-2 d-flex justify-content-center">
        <b-button @click="submitpost()" class="pr-5 pl-5">CREATE TICKET</b-button>
      </div>
    </b-container>
  </b-modal>
      <b-modal hide-header hide-footer  v-model="modaldepartments" size="lg" id="modal-xl2" v-if="user.userLevel == 0"  title="Choose category">
        <b-container>
          <h3 class="text-center" > <strong>Choose category</strong></h3>
          <div v-if="typeof user.mentorDetail != 'undefined' && modaldepartmentsType === 'booking'" class="text-center">
          Accessing professional experts for mentoring at your finger tips.<br>
          Feel burned out and want to avoid noob mistakes, mentor will help you achieve your goals faster.
        </div>
          <h6  class="mt-4" v-if="typeof user.mentorDetail != 'undefined' && modaldepartmentsType === 'booking'"><strong>Mentor </strong>{{user.mentorDetail.detailUser[0].name}} {{user.mentorDetail.detailUser[0].surname}}</h6>
            <b-row class="mt-4">
          <b-col @click="adddepartment(val)" style="cursor:pointer" v-for="val in departmentsmock" :key="val.id" cols="12" sm="6"  md="6">
            <div v-if="typeof user.mentorDetail == 'undefined' || modaldepartmentsType !== 'booking'">
              <b-card class="mb-3" >
                <b-card-text>
                <h6 class="mb-0"> {{ val.value }}</h6>
                <!-- <small>{{val.value}}</small> -->
                </b-card-text>
              </b-card>
            </div>
            <div v-else v-for="(data,index) in user.mentorDetail.detailUser[0].industryExpertise" :key="index">
              <b-card class="mb-3" v-if="data.name == val.value">
                <b-card-text>
                <h6 class="mb-0"> {{ val.value }}</h6>
                <!-- <small>{{val.value}}</small> -->
                </b-card-text>
              </b-card>
            </div>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
       <b-modal hide-header hide-footer ref="my-modal" v-model="modaladdticket_success" size="lg" id="modal-success">
        <b-container>
          <div class="text-right close-button" @click="hideModal()">
            <i class="fas fa-times"></i>
          </div>
          <i style="font-size:3rem" class="fas fa-check-circle mt-4 blue"></i>
          <h3 class="mt-4 blue">Your ticket has been successfully created</h3>
          <h5 class="mt-4"><strong>Ticket number {{createTicketNo}}</strong>  </h5>
          <router-link :to="'/detail/'+createTicketId" class="px-5 py-2 d-inline-block btn-secondary mt-3"
           >VIEW TICKET</router-link>
        </b-container>
      </b-modal>
      <vue-element-loading :active="loading" :is-full-screen="true"/>
    <div id="mySidenav" :class="{activesidenav : isfilter}" class="sidenav">
      <div id="closesidebar">
        <a  class="closebtn" @click="closeNav()">&times;</a>
        <!-- <a>Filters</a> -->
        <div style="position:relative">
          <a>SEVERITY</a>
          <hr/>
        </div>
          <b-form-checkbox
            v-for="(data,index) in optionseverity" :key="index"
              v-model="SEVERITY"
              :value="data.value"
          >
            {{data.text}}
          </b-form-checkbox>
                  
          <div style="position:relative" class="mt-4">
            <a>STATUS TICKET</a>
            <hr/>
          </div>

          <b-form-checkbox
            v-model="Statusticket"
            :value="1"
          >
          Open
          </b-form-checkbox>
          <b-form-checkbox
            v-model="Statusticket"
            :value="2"
          >
            <!-- unchecked-value="not_accepted" -->
          Answered
          </b-form-checkbox>
              <b-form-checkbox
            v-model="Statusticket"
            :value="4"
          >
          In process
          </b-form-checkbox>
              <b-form-checkbox
            v-model="Statusticket"
            :value="5"
          >
          Company-reply
          </b-form-checkbox>
            <b-form-checkbox
            v-model="Statusticket"
            :value="3"
          >
          On hold
          </b-form-checkbox>
                  <b-form-checkbox
            v-model="Statusticket"
            :value="6"
          >
          Closed
          </b-form-checkbox>

          <div style="position:relative" class="mt-4">
                  <a>CATEGORY </a>
                  <hr/>
          </div>
          <b-form-checkbox
            v-model="CATEGORY"
            :value="index"
            v-for="(item, index) in departmentsmocklimit" :key="index"
            >
          {{item.value}}
          </b-form-checkbox>
        
          <div class="mt-2 mb-2" >
            <span v-if="departmentsmock.length != departmentsmocklimit.length" class="blue" @click="MoreCat()">More</span>
          </div>
          <div class="py-2 mb-5 tCenter">
            <b-button @click="SEVERITY = [],Statusticket=[],CATEGORY=[]"  class="clearfilter tCenter" >
              CLEAR ALL FILTERS
            </b-button>
          </div>
      </div>
    </div>
    <div id="mySidenav" :class="{activesidenav : isfilterAll}" class="sidenav">
      <div id="closesidebar">
        <a  class="closebtn" @click="closeNav()">&times;</a>
        <!-- <a>Filters</a> -->
        <div style="position:relative">
          <a>SEVERITY</a>
          <hr/>
        </div>
          <b-form-checkbox
            v-for="(data,index) in optionseverity" :key="index"
              v-model="SEVERITYAll"
              :value="data.value"
          >
            {{data.text}}
          </b-form-checkbox>
                  
          <div style="position:relative" class="mt-4">
            <a>STATUS TICKET</a>
            <hr/>
          </div>

          <b-form-checkbox
            v-model="StatusticketAll"
            :value="1"
          >
          Open
          </b-form-checkbox>
          <b-form-checkbox
            v-model="StatusticketAll"
            :value="2"
          >
            <!-- unchecked-value="not_accepted" -->
          Answered
          </b-form-checkbox>
              <b-form-checkbox
            v-model="StatusticketAll"
            :value="4"
          >
          In process
          </b-form-checkbox>
              <b-form-checkbox
            v-model="StatusticketAll"
            :value="5"
          >
          Company-reply
          </b-form-checkbox>
            <b-form-checkbox
            v-model="StatusticketAll"
            :value="3"
          >
          On hold
          </b-form-checkbox>
                  <b-form-checkbox
            v-model="StatusticketAll"
            :value="6"
          >
          Closed
          </b-form-checkbox>

          <div style="position:relative" class="mt-4">
                  <a>CATEGORY </a>
                  <hr/>
          </div>
          <b-form-checkbox
            v-model="CATEGORYAll"
            :value="index"
            v-for="(item, index) in departmentsmocklimit" :key="index"
            >
          {{item.value}}
          </b-form-checkbox>
        
          <div class="mt-2 mb-2" >
            <span v-if="departmentsmock.length != departmentsmocklimit.length" class="blue" @click="MoreCat()">More</span>
          </div>
          <div class="py-2 mb-5 tCenter">
            <b-button @click="SEVERITYAll =[],StatusticketAll=[],CATEGORYAll=[]"  class="clearfilter " >
              CLEAR ALL FILTERS
            </b-button>
          </div>
      </div>
    </div>
   </b-container >
</template>
<script>
import Swal from 'sweetalert2'
import moment from "moment";
import { mapState } from "vuex";
import {HTTPTICKET,HTTPMentor,HTTPDynamic} from "@/axios";
import axios from "axios";
import router from '../router'
export default {
  name: 'HelloWorld',
  data () {
    return {
      isBusy:false,
      isfilter:false, 
      isfilterAll:false,
      SEVERITY:[],
      Statusticket:[],
      CATEGORY:[],
      SEVERITYAll:[],
      StatusticketAll:[],
      CATEGORYAll:[],
      allCategory:[],
      departmentsmock:[],
       modaldepartments:false,
       dismissSecs: 10,
        dismissCountDown: 0,
        loading:false,
        text:null,
        record:[],
        createTicketId:'',
        selectrecord:[
          { key: 'ticketNo', label: 'Ticket No.', sortable: true, class: 'text-center align-middle arrow' },
          { key: 'subject', label: 'Subject', sortable: true, sortDirection: 'desc',class:'align-middle arrow' },
          { key: 'status', label: 'Status', class:'status align-middle arrow' },
          { key: 'category', label: 'Category',class:'align-middle' },
          { key: 'createDate', label: 'Created date', sortable: true,class:'align-middle arrow' },
          { key: 'updateDate', label: 'Last Updated', sortable: true,class:'align-middle arrow' },
          { key: 'isclose', label: '',class:'view align-middle arrow' },
        ],
        selectrecordMentor:[
          { key: 'ticketNo', label: 'Ticket No.', sortable: true, class: 'text-center align-middle arrow' },
          { key: 'severityStatus', label: 'Severity', sortable: true, sortDirection: 'desc',class:'align-middle arrow text-center' },
          { key: 'subject', label: 'Subject', sortable: true, sortDirection: 'desc',class:'align-middle arrow' },
          { key: 'status', label: 'Status', class:'status align-middle'},
          { key: 'category', label: 'Category',class:'align-middle arrow' },
          { key: 'createDate', label: 'Created date', sortable: true, class:'align-middle arrow'},
          { key: 'updateDate', label: 'Last Updated', sortable: true, class:'align-middle arrow'},
          { key: 'isclose', label: '',class:'view arrow align-middle' },
        ],
        form: {
          email: '',
          name: '',
          food: null,
          checked: []
        },
        createTicketNo:0,
        ticketAll:[],
        totalRowsAll:1,
        currentPageAll: 1,
        perPageAll: 10,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        optionsinvesting:[],
        optionseverity:[
          { value: 1, text: 'Low' },
          { value: 2, text: 'Modarate' },
          { value: 3, text: 'High' },
          { value: 4, text: 'Critical' },
        ],
         options: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ],
        selected:null,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        sortByAll: null,
        sortDescAll: false,
        sortDirectionAll: 'asc',
        filter: null,
        filterAll: null,
        infoModal: {
          id: 'info-modal',
          title: '',
        content: '',
        },
        newservice:{
          selectinvesting:'Food for the future',
          topic:'',
          detail:'',
          selectedSeverity:0,
          file:[],
        },
        interestedinvesting:[],
        modalservice:false,
        modaladdticket_success:false,
        alertcontent:'',
        category_select:'',
        limitCat:5,
        modaldepartmentsType:''
      }
  },
  created(){
    
    if(this.user.userLevel != 50){
      console.log('1')
      if(typeof this.user.mentorDetail == 'undefined'){
        console.log('2')
        this.getAllCategory()
      }else{
        console.log('3')
        console.log('asdasdasdw3sad',this.user.mentorDetail)
        this.user.mentorDetail.detailUser[0].industryExpertise.map(res =>{
          this.departmentsmock.push({value:res.name,index:res.index})
        })  
      }
    }else{
      console.log('4')
      this.getAllCategory()
    }
    this.getAllCategoryConst()
  },
  mounted(){
   
    this.isBusy = true
    //this.fetchdatainvest()
    this.getallrecord()
    this.getTypeOfBusiness()
    if(this.user.userLevel == 50){
      this.mentorGetPublic()
    }
    if(typeof this.user.mentorDetail !='undefined' && this.user.mentorDetail != null && this.user.mentorDetail != '' &&typeof this.user.mentorDetail.userId !='undefined' && this.user.mentorDetail.userId != '' && this.isOpenModalCreate){
      this.modaldepartments = true;
      this.modaldepartmentsType = 'booking'
      this.$store.commit('setOpenModalCreate',false)

    }else{
      this.modaldepartments = false;
    }
    this.addmorefile()
  },
    computed: {
      
       ...mapState(["user","typeOfBusiness","isOpenModalCreate"]),
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      user(){
        return this.$store.state.user
      },
      loginalready(){
        return this.$store.state.user.loginalready
      },
      token(){
        return this.$store.state.token
      },
      departmentsmocklimit(){
        return this.departmentsmock.slice(0,this.limitCat)
      },
      filterCateGory(){
        if(typeof this.CATEGORY !=='undefined' && this.CATEGORY.length > 0){
          let allCat =[]
          this.record.map(item =>{
            this.CATEGORY.filter(data =>{
            if(data == item.category){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.record  
        }
      },  
      filterStatus(){
        if(typeof this.Statusticket !='undefined' && this.Statusticket.length > 0){
          let allCat =[]
          this.filterCateGory.map(item =>{
            this.Statusticket.filter(data =>{
            if(data == item.status){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.filterCateGory
        }
      },
      filterSererity(){
        if(typeof this.SEVERITY !='undefined' && this.SEVERITY.length > 0){
          let allCat =[]
          this.filterStatus.map(item =>{
            this.SEVERITY.filter(data =>{
            if(data == item.severityStatus){
              allCat.push(item)
              }
            })
          })
          console.log('allcat',allCat)
          return allCat
        }else{
          console.log('filterStatus',this.filterStatus)
          return this.filterStatus
        }
      },
      filterCat(){
        if(typeof this.CATEGORYAll !=='undefined' && this.CATEGORYAll.length > 0){
          let allCat =[]
          this.ticketAll.map(item =>{
            this.CATEGORYAll.filter(data =>{
            if(data == item.category){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.ticketAll  
        }
      },  
      filterStatusAll(){
        if(typeof this.StatusticketAll !='undefined' && this.StatusticketAll.length > 0){
          let allCat =[]
          this.filterCat.map(item =>{
            this.StatusticketAll.filter(data =>{
            if(data == item.status){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.filterCat
        }
      },
      filterSererityAll(){
        if(typeof this.SEVERITYAll !='undefined' && this.SEVERITYAll.length > 0){
          let allCat =[]
          this.filterStatusAll.map(item =>{
            this.SEVERITYAll.filter(data =>{
            if(data == item.severityStatus){
              allCat.push(item)
              }
            })
          })
          return allCat
        }else{
          return this.filterStatusAll
        }
      },
      checkToken(){
        return this.$store.state.checkToken
      },
      typeOfBusinessConst(){
        return this.$store.state.typeOfBusinessConst
      }  
    },
    methods:{
       hideModal() {
        this.$refs['my-modal'].hide()
      },
      addmorefile(){
         this.newservice.file.push({fileName : null,status:null}) 
      }, 
      delFile(index){ 
        this.newservice.file.splice(index,1) 
      },
       MoreCat(){
          this.limitCat += 5;
        },

      checkNameCategory(value){
          let data =  this.typeOfBusinessConst.filter(search =>{
            return search.index == value
          })
          if(data.length > 0){
            return data[0].value
          }else{
            return ''
          }
      },
      getAllCategoryConst(){
        let department = []
        HTTPTICKET.post('/api/get/all/category').then(res=>{
          let data = []
          if(res.data.success){
            res.data.obj.map(val =>{
              department.push({value:val.name,index:val.index})
            })
          }
        })
        this.$store.commit('setTypeOfBusinessConst',department)
      },
      getAllCategory(){
        HTTPTICKET.post('/api/get/all/category').then(res=>{
          let data = []

          if(res.data.success){
            res.data.obj.map(val =>{
              this.departmentsmock.push({value:val.name,index:val.index})
            })

            console.log('/api/get/all/category',this.departmentsmock)
            // this.departmentsmock.slice(0,this.limitCat)

          }
        })
        console.log('/api/get/all/category',this.departmentsmock)
      },
      getTypeOfBusiness(){
        HTTPTICKET.post('/api/get/type/of/business').then(res=>{
          console.log("/api/get/type/of/business",res)
          let data = []
          if(res.data.success){
            res.data.obj.map(val =>{
              data.push({value:val.index,text:val.name})
              this.$store.commit('setTypeOfBusiness',data)
            })
          }
        })
      },

      openNav(){
        if(this.isfilter){
          this.$store.commit('profilemenumargin',false)
          this.isfilter = false
        }else{
           this.$store.commit('profilemenumargin',true)
          this.isfilter = true
        }
      },
      openNavAll(){
        if(this.isfilterAll){
          // this.$store.commit('profilemenumargin',false)
          this.isfilterAll = false
        }else{
          // this.$store.commit('profilemenumargin',true)
          this.isfilterAll = true
        }
      },
      closeNav(){
          this.$store.commit('profilemenumargin',false)
          this.isfilter = false
          this.isfilterAll = false
      },
      backcategory(){
        this.modaldepartments = true
        this.modalservice = false
      },
      errorcatch(){
        Swal.fire(
        'Error',
        'Please check your network connection',
        'error'
        )
      },
      adddepartment(val){
        this.category_select = val.index
        this.modaldepartments = false
        this.modalservice = true
      },
      covertime(value){
        // console.log(value)
        if (value) {
            var t = moment(value).format("DD MMMM YYYY h:mm a")
            return t;
          }
      },
      showAlert(val) {
        this.dismissCountDown = this.dismissSecs
        this.alertcontent = val
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      uploadfile_post(event,index){
          this.newservice.file[index].status = 2
          let formData = new FormData();
          formData.append("file", event.target.files[0]);
          HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          HTTPTICKET.post(`/upload/ticket`,formData)
          .then(res => {
              console.log("upload/postFile",res);
              if (res.data.success) {
                this.newservice.file[index].fileName = res.data.obj
                this.newservice.file[index].status = 1
              }else{
                this.newservice.file[index].status = 0
              }
          })
          .catch(e => {  
            this.errorcatch()
            this.newservice.file[index].status = 0
            console.log("upload/postFile/error",e);
          });
      },
      submitpost(){
        this.loading=true
        var data= {
          profile:this.user.profilePic,
          typeSystem:this.user.typeSystem,
          category:this.category_select,
          industry:this.newservice.selectinvesting,
          subject:this.newservice.topic,
          mentorId:(this.user.mentorDetail != null && typeof this.user.mentorDetail != 'undefined' && this.modaldepartmentsType === 'booking') ? this.user.mentorDetail.userId : '',
          // ownedBy:this.user.userId,
          detail:this.newservice.detail,
          status:1,
          severityStatus:this.newservice.selectedSeverity,
          postFile:this.newservice.file
        } 
        console.log('created',data)
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        HTTPTICKET.post(`/api/create/ticket`,data).then(res => {
          console.log(`/api/create/ticket`,res)
          
          if (res.data.success) {
            // this.showAlert("Add New Service Request Success")
            this.createTicketNo = res.data.obj.ticketNumer
            this.createTicketId = res.data.obj.ticketId
            this.modaladdticket_success = true
            this.modalservice = false
            this.getallrecord()
            this.newservice={
              selectinvesting:'Food for the future',
              topic:'',
              detail:'',
              selectedSeverity:0,
              file:null,
              uploadfilesuccess:[{
              fileName:null
            }],
            }
          }
          this.loading=false
        })
        .catch(e => {  
          this.errorcatch()
          this.loading = false
            console.log("/api/create/ticket",e);
        });
      },
      cutNewTicket(){
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          let url = ''
          if(this.user.userLevel == 50){
            url = "/api/mentor/get/ticket"
          }else{
            url = "/api/get/ticket/by/user/Id"
          }
          HTTPTICKET.post(url).then(res => {
          //console.log(url, res);  
            if (res.data.success) {
            //  this.record = res.data.obj
            let first = {}
            let addindex = res.data.obj.map((x,index) =>{
              if(index+1 == res.data.obj.length){
                first = {
                  index: index+1,
                  ...x,
                }
                console.log('do')
              }else{
                var data = {
                  index: index+1,
                  ...x,
                }
                return data
              }
            })
           
            addindex.sort((a, b) => {
              const modifier = -1;
              if (new Date(a.updateDate) < new Date(b.updateDate)) return -1 * modifier;
              if (new Date(a.updateDate) > new Date(b.updateDate)) return 1 * modifier;
              return 0;
            }); 
            addindex.unshift(first)
             this.record = addindex
             this.totalRows = this.record.length
            //  console.log('this.record',this.record)
             this.isBusy = false
            }else{}
            setTimeout(()=>{
              this.isBusy = false
            },7000)
          })
          .catch(e => {
            this.errorcatch()
              console.log("/api/get/ticket/by/user/Id",e);
               this.isBusy = false
          })
      },
      mentorGetPublic(){
        let array = []
        this.user.industryExpertise.map(val =>{
          array.push(val.index)
        })
        let data ={
          cate:array
        }
        console.log(data)
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        HTTPTICKET.post('/api/get/public/ticket',data).then(res=>{
          console.log('/api/get/public/ticket',res)
          if (res.data.success) {

          let addindex = []
          res.data.data.map((x,index) =>{
            var data = {
              index: index+1,
              ...x,
            }
            addindex.push(data)
          })
          addindex.sort((a, b) => {
            const modifier = -1;
            if (new Date(a.updateDate) < new Date(b.updateDate)) return -1 * modifier;
            if (new Date(a.updateDate) > new Date(b.updateDate)) return 1 * modifier;
            return 0;
          });
           this.ticketAll = addindex
           this.totalRowsAll = this.ticketAll.length
           console.log('this.ticketAll',this.ticketAll)
           this.isBusy = false
          }else{}
          setTimeout(()=>{
            this.isBusy = false
          },7000)
        })
      },
      getallrecord(){
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        let url = ''
        if(this.user.userLevel == 50){
          url = "/api/mentor/get/ticket"
        }else{
          url = "/api/get/ticket/by/user/Id"
        }
        HTTPTICKET.post(url).then(res => {
        console.log(url, res);  

          if (res.data.success) {
          //  this.record = res.data.obj
          let addindex = res.data.obj.map((x,index) =>{
            var data = {
              index: index+1,
              ...x,
            }
            return data
          })
          addindex.sort((a, b) => {
            const modifier = -1;
            if (new Date(a.updateDate) < new Date(b.updateDate)) return -1 * modifier;
            if (new Date(a.updateDate) > new Date(b.updateDate)) return 1 * modifier;
            return 0;
          });
           this.record = addindex
           this.totalRows = this.record.length
           //console.log('this.record',this.record)
           this.isBusy = false
          }else{}
          setTimeout(()=>{
            this.isBusy = false
          },7000)
        })
        .catch(e => {
          this.errorcatch()
            console.log("/api/get/ticket/by/user/Id",e);
             this.isBusy = false
        })
      }, 
      changerouter(val){
        this.$router.push('/detail/'+val._id);
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        console.log('filter',filteredItems)
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      onFilteredAll(filteredItems) {
        this.totalRowsAll = filteredItems.length
        this.currentPageAll = 1
      },

      fetchdatainvest(){
          let data ={
            keyRequest:this.token
          }
          HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          HTTPDynamic.post(`api/get/form`,data).then(res => {
          console.log('api/get/form',res.data)
          if (res.data.success) {
            this.interestedinvesting = res.data.obj.form[1].component.components[0].componentData[5].display
            console.log(this.interestedinvesting)
            let mapoption = res.data.obj.form[1].component.components[0].componentData[5].display.value.map(val =>{
             var data =  { value: val.label , text: val.label }
             return data
            })
            this.optionsinvesting = mapoption
            this.getallrecord()
          }
        })
        .catch(e => {  
            this.errorcatch()
            console.log("api/get/form",e);
        });
        this.getallrecord()
      },
      openCreatMentor(){
        this.modaldepartments = !this.modaldepartments
        this.modaldepartmentsType='create'
        this.departmentsmock = []
        this.getAllCategory()
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$filter :linear-gradient(180deg, #0D6ACA -34.44%, #0FB9F4 120%);
$grey :#C4C4C4;
$CLOSED: #E70000;
$OPEN: #0D6ACA;
$ONHOLD: #FD7900;
$COMPANY-REPLY: #0FB9F4;
$ANSWERED: #0ABA06;
$inprocress:#FFCB2A;

@media only screen and (max-width: 576px) {
  .tCenter{
    text-align: center!important;
  }

}

.custom-control{
      min-height: 1.9rem;
}
.close-button{
  position:absolute;
  top:5%;
  right:5%;
}
.clearfilter{
  background: white;
  color: $ONHOLD;
  box-shadow: 0 0 0 1px $ONHOLD;
}
#Filters{
  background-image: $filter;
}

.blue{
  color:$COMPANY-REPLY;
}
.orange{
  color: $ONHOLD;
}
.grey{
  color: $grey
}
.abcenter{
  position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%)
}
#modal-xl2 .modal-body{
  padding: 2rem 5rem;
}
#modal-xl2 .card-body{
  padding: 0.85rem;
}
#modal-xl2 .card:hover{
  border-color: $COMPANY-REPLY;
  color: $COMPANY-REPLY;
}

.input-group{
  position: relative;
}

.fa-search{
      position: absolute;
    z-index: 20;
    color: #C4C4C4;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
}
.card-body{
  text-align: center;
}
.alert-success{
      position: relative;
    top: 30px;
}
.btn-outline-primary{
  border-radius: 30px;
}

.btn-secondary{
background-color: white;
    border-color: white;
    border-radius: 30px;
   
}
.CLOSED{
  border-color: $CLOSED;
  white-space: nowrap;
  background-image: linear-gradient($CLOSED, $CLOSED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   

}
.OPEN{
  border-color: $OPEN;
  background-image: linear-gradient($OPEN, $OPEN);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ONHOLD{
   border-color: $ONHOLD;
  background-image: linear-gradient($ONHOLD, $ONHOLD);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.COMPANY-REPLY{
  border-color: $COMPANY-REPLY;
  background-image: linear-gradient($COMPANY-REPLY, $COMPANY-REPLY);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ANSWERED{
    border-color: $ANSWERED;
  background-image: linear-gradient($ANSWERED, $ANSWERED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
    white-space: nowrap;
}
.inprocress{
    border-color: $inprocress;
  background-image: linear-gradient($inprocress, $inprocress);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
    white-space: nowrap;
}
//  border-color: $orange-top;
//     background-image: linear-gradient($orange-top, $orange-bottom);
//    border-color: $orange-top;
// menu 
/* menumenumenu */
#Filters.activefilter{
  border: 1px solid #0D6ACA !important;
  background: transparent !important;
}

#Filters.activefilter span,#Filters.activefilter i{
  color: #0D6ACA !important;
}
.sidenav {
      /* background: ; */
  box-shadow: -10px 0px 10px 1px rgba(0,0,0,0.15);
  z-index: 99;
  height: 100%;
  width: 0;
  position: fixed;
  top: 0;
  right: 0;
  background-color: white;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 50px 20px 0 20px;
}

.sidenav a {
    // padding: 0 0 10px 0;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    color: black;
    display: block;
    transition: 0.3s;
    text-align: left;
}
.sidenav a.language{
  display: inline-block;
  width: 45%;
  word-break: break-word;
}
.sidenav a:hover {
 color: black;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

#closesidebar{
  width: 0;
  padding: 0;
  opacity: 0;
  margin-left: 0;
}
#mySidenav{
    position:fixed;
    width:400px;
    right:-500px;
    transition: all 0.4s;
    --webkit-transition: all 0.4s;
    padding:50px 20px 0 20px;
}
#mySidenav.activesidenav{
  right:0px;
}
.activesidenav #closesidebar{
  width:400px;
  opacity:1;
 transition: 0.5s
}
// menu
@media only screen and (max-width: 403px) {
  #mySidenav.activesidenav,.activesidenav #closesidebar{
  width:100vw;
  left: 0
}
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
.status-btn{
  width: 75%;
  height: 30px
}
.css-btn{
  display: flex; 
  align-items: center; 
  justify-content: center; 
  color: white;
  font-weight: 400;
}
.head-middle{
  vertical-align: middle!important;
}
.closebtn{
  cursor: pointer!important;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue